module.exports = __webpack_public_path__ + "img/logo-pgj.12cd8f54.png";